import { decompress, strFromU8 } from "fflate";
function DecompressRgObjectDtoAsync(obj) {
	return new Promise((resolve, reject) => {
		decompress(obj, (err, data) => {
			if (err) return reject(err);
			resolve(JSON.parse(strFromU8(data)));
		});
	});
}
export { DecompressRgObjectDtoAsync };

//# sourceMappingURL=index198.js.map